import React from 'react';

type LocalDateTimeProps = {
  utcDate: string | Date | undefined;
  formatOptions?: Intl.DateTimeFormatOptions;
  locale?: string;
};

const LocalDateTime: React.FC<LocalDateTimeProps> = ({
  utcDate,
  formatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
  locale = 'en-AU',
}) => {
  const localString = new Date(utcDate).toLocaleString(locale, formatOptions);

  return <>{localString}</>;
};

export default LocalDateTime;
